module.exports = __webpack_public_path__ + "img/roobroo-logo.91555acd.png";